<template>
  <div>
    <!--卡片布局-->
    <el-card shadow="always">
      <!--操作栏-->
      <div class="search-items">
        <div>
          <el-input size="small" v-model="queryInfo.queryStr" placeholder="请输入课程名或编号进行查询" clearable @clear="loadData()">
            <el-button size="small" slot="append" icon="el-icon-search" @click="loadData()"></el-button>
          </el-input>
        </div>
        <div v-if="isAdmin">
          <el-button size="small" type="primary" @click="handleAdd()">添加</el-button>
          <el-button size="small" type="danger" @click="handleDeleteMulti()">删除所选</el-button>
        </div>
      </div>
      <!--表格-->
      <el-table :data="tableData" stripe border style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50">
        </el-table-column>
        <el-table-column prop="cno" width="120" label="课程编号">
        </el-table-column>
        <el-table-column prop="name" width="160" label="课程名称">
        </el-table-column>
        <el-table-column prop="tnames"  width="120" label="任课教师">         
        </el-table-column>
        <el-table-column label="图文介绍" >
          <template slot-scope="scope">
             <div @click="openImageTextDialog(scope.row.imageText)" style="color:#59a6ff;cursor: pointer">
                <el-button type="text" size="mini" icon="el-icon-thumb"></el-button>
                {{scope.row.introduction}}
            </div>
            <!-- <el-button type="text" @click="openImageTextDialog(scope.row.imageText)" icon="el-icon-thumb"> {{scope.row.introduction}}
            </el-button> -->
          </template>
        </el-table-column>        
        <!-- <el-table-column label="课程图片">
          <template slot-scope="scope">
            <img v-for="item in scope.row.pictureArr" :key="item" style="height: 80px;" :src="item">
          </template>
        </el-table-column>
        <el-table-column prop="introduction" label="课程介绍">         
        </el-table-column> -->
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="handleUpdate(scope.row)"></el-button>
            <el-button v-if="isAdmin" type="danger" icon="el-icon-delete" @click="handleDeleteOne(scope.row.id)" size="mini"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.currentPage" :page-sizes="[1,5,10,100,1000]" :page-size="queryInfo.pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
    <el-dialog title="课程图文介绍" :visible.sync="imageTextDialogFlag" @close="closeImageTextDialog">
      <div v-html='imageText'>      
      </div>
    </el-dialog>    
  </div>
</template>

<script>
import { mapState } from "vuex"
import { selectCourseList, deleteCourse } from '@/api/course'
// import { selectAllTeacher } from '@/api/teacher'
import CommonUtil from "@utils/common-util"
import { PICTURES } from "@utils/constant"
export default {
  inject: ['reload'],
  name: "courseIndex",
  data() {
    return {
      formLabelWidth: '120px',
      selectNos: [],
      tableData: [],       //分页查询所有数据
      queryInfo: {
        queryStr: '',
        currentPage: 1,
        pageSize: 100
      },
      total: 0,
      file: null,
      allTableData: [],     //表格所有数据
      multipleSelection: [],
      testImages: PICTURES,
      teachers:null,
      imageTextDialogFlag:false,
      imageText:'',
      account:localStorage.getItem('account'),  
    }
  },
  created() {
    this.loadData();//分页条件获取所有学生信息
  },
  computed: {
     ...mapState({      
      userRoles: ({ user }) => user.roles,
    }), 
    isAdmin(){
      return _.includes(this.userRoles,'superAdmin')
    } 
  },    
  methods: {
    //添加对象
    handleAdd() {
      this.$router.push('/baseInfo/courseAdd');
    },
    //编辑对象 
    handleUpdate(row) {
      this.$router.push({path:'/baseInfo/courseUpdate',query:{cno:row.cno}});
    },
    //删除多个
    handleDeleteMulti() {
      let ids = []
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        ids = _.map(this.multipleSelection, 'id')
        // formData.append('ids', ids);
      }
      CommonUtil.deleteMultiple(ids,deleteCourse, this.loadData)
    },
    //删除
    handleDeleteOne(id) {
      // let params = { cno: cno }
      CommonUtil.deleteOne([id], deleteCourse, this.loadData)
    },

    handleSelectionChange(val) {
      //监听多选框值动态变化的事件
      this.multipleSelection = val;
    },
    //加载列表数据
    async loadData() {
      // let teacherResp = await selectAllTeacher()
      // this.teachers = teacherResp.data.data
      //分页条件获取所有学生信息     
      let params = {
        account:this.isAdmin?"":this.account,
        queryStr: this.queryInfo.queryStr,
        currentPage: this.queryInfo.currentPage,
        pageSize: this.queryInfo.pageSize
      }
      selectCourseList(params).then(response => {
        let rowDatas = response.data.data.entries;
        _.forEach(rowDatas, (obj) => {
          obj['pictureArr'] = obj.pictures?_.split(obj.pictures, ','):[]
        })
        this.tableData = rowDatas
        this.total = response.data.data.total;
      });
    },
    changeFile(file) {
      //改变文件触发事件
      this.file = file;
    },
    beforeRemove(file) {
      //移除文件触发事件
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSizeChange(val) {
      //监听pageSize
      this.queryInfo.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      //监听currentPage
      this.queryInfo.currentPage = val;
      this.loadData();
    },
    getAllCourse() {
      //用于excel的导出
      this.common.getAllData(this, this.apiUrl.selectAllCourses);
    },
    openImageTextDialog(imageText){
      this.imageTextDialogFlag = true
      this.imageText = imageText
    },    
    closeImageTextDialog(){
      this.imageTextDialogFlag = false
    }
  }
}
</script>

